import {Address} from '../../../addresses/models/address.model';
import {ServicePointModel} from '../models/service-point.model';

export function getCompactAddressDisplay(address?: Address): string {
  if (!address) {
    return '';
  }
  const parts = [address.state, address.city, address.zipCode].filter(Boolean);
  return parts.join(', ');
}

export function getServicePointDisplayText(address?: Address, externalId?: string): string {
  if (!address) {
    return '';
  }
  const resolvedExternalId = externalId || (address as Address & { externalId?: string }).externalId;
  const place = getCompactAddressDisplay(address);
  if (!place) {
    return '';
  }
  return resolvedExternalId ? `${resolvedExternalId} ${place}` : place;
}

export function getServicePointLabel(servicePoint?: ServicePointModel): string {
  const place = getCompactAddressDisplay(servicePoint?.address) || servicePoint?.name || '';
  if (!place) {
    return '';
  }
  return servicePoint?.externalId ? `${servicePoint.externalId} - ${place}` : place;
}
